import { render, staticRenderFns } from "./NiceAuth.vue?vue&type=template&id=5580165a&"
import script from "./NiceAuth.vue?vue&type=script&lang=js&"
export * from "./NiceAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports